/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconNavigationStartpage = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M14.858 6.816L8.994 2.791a1.684 1.684 0 0 0-1.67.01l-6.173 4.01a.334.334 0 0 0 .363.559l1.485-.965v6.687c0 .184.149.333.333.333h2.667a.333.333 0 0 0 .333-.333V9.425h3.334v3.667c0 .184.149.333.333.333h2.667a.333.333 0 0 0 .333-.333V6.351l1.478 1.015a.334.334 0 0 0 .378-.55z"
    />
  </svg>
);

IconNavigationStartpage.displayName = 'IconNavigationStartpage';

IconNavigationStartpage.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconNavigationStartpage);
IconNavigationStartpage.displayName = 'IconNavigationStartpage';
